<template>
    <div id="cfsBatchUpdate">
        <a-modal v-model="visible" :title="labelName" :maskClosable="false"  >
            <template slot="footer">
                <a-button size="small" type="primary" @click="save">Save</a-button>
            </template>
            <a-form :form="form" >
                <a-form-item :label="labelMAWB"  v-bind="formItemLayout" >
                    <a-input size="small" style="width: 80%" v-model="inputMAWB"/>
                </a-form-item>
                <a-form-item :label="$t('flightNo')"  v-bind="formItemLayout" >
                    <a-input size="small" style="width: 80%" v-model="inputFlightNo"/>
                </a-form-item>
                <a-form-item :label="$t('airLine')"  v-bind="formItemLayout" >
                    <a-select v-model="inputAirline" style="width: 100%;" size="small" :placeholder="$t('publicLang.PleaseSelect')">
                        <a-select-option v-for="item in localData.SKYNET_CARRIER" :value="item.CODE">
                            {{item.CODE_DESC}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item :label="$t('shipFrom')"  v-bind="formItemLayout" >
                    <a-select v-model="inputShipFrom" style="width: 100%;" size="small" :placeholder="$t('publicLang.PleaseSelect')">
                        <a-select-option v-for="item in localData.SKYNET_SHIP_LOC" :value="item.CODE">
                            {{item.CODE_DESC}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item :label="$t('shipTime')"  v-bind="formItemLayout">
                    <a-date-picker
                            :placeholder="$t('publicLang.PleaseSelect')"
                            format="YYYY-MM-DD HH:mm"
                            size="small"
                            show-time
                            v-model="inputShipTime"
                            :disabled-date="disabledArrivedDate"/>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import moment from "moment";
    export default{
        data(){
            return{
                labelName: '',
                labelMAWB:'MAWB#',
                inputMAWB:'',
                inputFlightNo:'',
                inputAirline:'',
                inputShipFrom:'HK',
                inputShipTime:'',
                visible: false,
                form:this.$form.createForm(this),
                localData: {},
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
            }
        },
        methods:{
            show(name,type,uids){
                this.uids = uids
                this.labelName = name
                this.visible = true
                this.ajaxtype = type
                this.localData = JSON.parse(sessionStorage.getItem('localData'))//获取下拉框中的值
            },
            save(){
                if(this.inputMAWB==''){
                    this.$customMessage.warning(this.labelMAWB+" is null")
                    return;
                }
                if(this.inputFlightNo==''){
                    this.$customMessage.warning(this.labelFlightNo+" is null")
                    return;
                }
                if(this.inputAirline==''){
                    this.$customMessage.warning(this.labelAirline+" is null")
                    return;
                }
                if(this.inputShipFrom==''){
                    this.$customMessage.warning(this.labelShipLoc+" is null")
                    return;
                }
                if(null == this.inputShipTime){
                    this.$customMessage.warning(this.labelShipTime+" is null")
                    return;
                }
                let params = {
                    "uids": this.uids,
                    "mawb": this.inputMAWB,
                    "flighNo": this.inputFlightNo,
                    "airline": this.inputAirline,
                    "shipLoc": this.inputShipFrom,
                    "shipTime": this.inputShipTime,
                }
                ajax.post(api.CFSSAVEMAWB,params).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg)
                        this.visible = false
                    }else{
                        this.$customMessage.warning(res.msg)
                    }
                })


            },
            disabledArrivedDate(current) {
                return current < moment().startOf('minute');//精确到分钟不可选
            },
        }
    }
</script>